// ContactList.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ContactModal from './ContactModal';
import SendAudioModal from './SendAudioModal'; // Importa o modal de áudio

const ContactList = ({ initialContacts, incrementSmsSent, fetchTotalization, pricePerSms }) => { 
  const navigate = useNavigate();

  const [userName, setUserName] = useState(localStorage.getItem('userName') || '');
  const [contacts, setContacts] = useState(initialContacts || []);
  const [smsSent, setSmsSent] = useState(0);
  const [contactModalOpen, setContactModalOpen] = useState(false);
  const [sendAudioModalOpen, setSendAudioModalOpen] = useState(false); // Novo estado para SendAudioModal
  const [selectedContact, setSelectedContact] = useState(null);
  const token = localStorage.getItem('token'); 

  const handleConfirmSend = async (phoneNumber, messageId) => {
    try {
      const response = await fetch('https://api2.apploja.com/smssender/sms_enviado.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          phoneNumber,
          id: messageId, // Enviando o messageId como id
          PrecoSMS: pricePerSms,
          EnviadoPor: userName
        }),
      });
      
      const result = await response.json();
      console.log("Preço SMS enviado para " + phoneNumber + " " + pricePerSms);

      if (response.ok) {
        const updatedContacts = contacts.filter(contact => contact.id !== messageId);
        setContacts(updatedContacts);
        const newSmsSentCount = smsSent + 1;
        setSmsSent(newSmsSentCount);
        fetchTotalization();

        if (newSmsSentCount % 150 === 0) {
          alert("Por favor troque o chip do celular");
        }

        if (updatedContacts.length > 0) {
          setSelectedContact(updatedContacts[0]);
          if (updatedContacts[0].TipoMensagem === 3) {
            setSendAudioModalOpen(true);
          } else {
            setContactModalOpen(true);
          }
        } else {
          setContactModalOpen(false);
          setSendAudioModalOpen(false);
        }
      } else {
        console.error('Erro ao enviar a requisição:', result.message);
      }
    } catch (error) {
      console.error('Erro na requisição HTTP:', error);
    }
  };

  const handleContactClick = (contact) => {
    setSelectedContact(contact);
    if (contact.TipoMensagem === 3) {
      setSendAudioModalOpen(true);
    } else {
      setContactModalOpen(true);
    }
  };

  return (
    <div className="w-full p-4 flex justify-center">
      <div className="w-full max-w-xs space-y-2">
        {contacts.length === 0 ? (
          <div className="text-center py-4">Nenhum contato disponível.</div>
        ) : (
          contacts.map((contact) => (
            <div
              key={contact.id}
              onClick={() => handleContactClick(contact)}
              className="bg-gray-100 border border-gray-300 p-2 my-1 rounded-lg flex flex-col space-y-2"
            >              
              <div className="flex items-center justify-between w-full">
                <div className="flex items-center">
                  <span className="text-xl mr-2">👤</span>
                </div>
                <span className="text-sm">{contact.nome}</span>
              </div>
              <div className="flex items-center justify-between w-full">
                <div className="flex items-center">
                  <span className="text-2xl mr-2">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="green" width="24" height="24" viewBox="0 0 24 24">
                      <path d="M6.62 10.79a15.05 15.05 0 006.57 6.57l2.2-2.2a1.5 1.5 0 011.59-.27c1.12.47 2.35.72 3.62.72a1.5 1.5 0 011.5 1.5V20a1.5 1.5 0 01-1.5 1.5A17.56 17.56 0 012 6.5 1.5 1.5 0 013.5 5H7a1.5 1.5 0 011.5 1.5c0 1.27.25 2.5.72 3.62a1.5 1.5 0 01-.27 1.59l-2.2 2.2z"/>
                    </svg>
                  </span>
                </div>
                <span className="text-sm font-semibold">{contact.telefone}</span>
              </div>
            </div>
          ))
        )}
      </div>

      {selectedContact && (
        <>
          {selectedContact.TipoMensagem !== 3 ? (
            <ContactModal
              isOpen={contactModalOpen}
              onClose={() => {
                setContactModalOpen(false);
                setSelectedContact(null);
              }}
              phoneNumber={selectedContact?.telefone}
              message={selectedContact?.mensagem}
              contactName={selectedContact?.nome}
              onConfirmSend={() => handleConfirmSend(selectedContact.telefone, selectedContact.id)}
              tipoMensagem={selectedContact?.TipoMensagem} 
              messageId={selectedContact?.ID} 
            />
          ) : (
            <SendAudioModal
              isOpen={sendAudioModalOpen}
              onClose={() => {
                setSendAudioModalOpen(false);
                setSelectedContact(null);
              }}
              phoneNumber={selectedContact?.telefone}
              message={selectedContact?.mensagem}
              contactName={selectedContact?.nome}
              tipoMensagem={selectedContact?.TipoMensagem}
              messageId={selectedContact?.id}
              onConfirmSend={handleConfirmSend} // Passa handleConfirmSend para SendAudioModal
            />
          )}
        </>
      )}
    </div>
  );
};

export default ContactList;